var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94442 5.82295C6.06451 6.29292 4.56647 6.68457 4.61542 6.69436C4.67417 6.69436 6.47574 6.99788 8.62 7.35037L12.5267 7.99658L15.9829 7.086C17.8824 6.58666 19.4294 6.16564 19.4196 6.15585C19.4099 6.14605 17.7062 5.89148 15.6305 5.58796C13.5547 5.28443 11.7532 5.02007 11.6161 5.00049C11.479 4.98091 9.83411 5.34318 7.94442 5.82295Z",
    fill: "#ED5E2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9525 7.61498C14.7495 8.19266 12.9381 8.68222 12.9186 8.7018C12.899 8.71159 12.899 11.1985 12.9088 14.2142L12.9381 19.6973L16.9427 17.8565C19.1359 16.848 20.9571 15.9962 20.9767 15.9766C20.9963 15.957 21.0061 13.8226 20.9963 11.2475L20.9669 6.55754L16.9525 7.61498Z",
    fill: "#ED5E2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.3737C3 16.1922 3.02937 17.5826 3.11749 17.6315C3.32311 17.7588 12.0568 19.7954 12.1351 19.7268C12.1743 19.6975 12.1939 17.2007 12.1841 14.185L12.1547 8.71178L7.99348 8.00682C5.70236 7.62497 3.64622 7.28228 3.42102 7.24311L3 7.18436V12.3737ZM10.5196 17.8763C11.0679 18.0134 11.2246 18.1211 11.2246 18.3659C11.2246 18.6694 10.921 18.7477 10.3336 18.6106C10.03 18.5421 9.73631 18.454 9.67756 18.4148C9.42299 18.2582 9.61882 17.7686 9.93213 17.7686C10.0007 17.7686 10.265 17.8176 10.5196 17.8763Z",
    fill: "#ED5E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.7a06aa23b6fc32eedf0788ebb407371f.svg";
export { ForwardRef as ReactComponent };